/*
 * @Author:chenxf
 * @Date: 2017-12-20 14:45:10
 * @Description: website网站管理
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-03-08 10:47:02
 */

// import api from "api/index";
import { queryNew } from '@/api/modules/logisticsManage'
const state = {
  showNewIcon: 0
}

const mutations = {
  newIcon(state, data) {
    state.showNewIcon = _.cloneDeep(data)
  }

}

const actions = {
  // 查询打款记录列表
  showNewIcon: async({ commit, state }, param) => {
    const data = await queryNew()
    if (data) {
      commit('newIcon', data)
    }
  }

}

const getters = {
  showNewIcon: state => state.showNewIcon

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
